/// <reference path='../../app.typings.d.ts' />
'use strict';
var app;
(function (app) {
    var Directives;
    (function (Directives) {
        var OrganizationSelectorLinkController = /** @class */ (function () {
            function OrganizationSelectorLinkController($scope) {
                this.$scope = $scope;
                this.location = OrganizationUnitType.Location;
            }
            OrganizationSelectorLinkController.prototype.organizationChanged = function (event, organizationCacheKey) {
                this.$scope.onOrganizationChange({ arg: organizationCacheKey });
            };
            OrganizationSelectorLinkController.$inject = [
                '$scope'
            ];
            return OrganizationSelectorLinkController;
        }());
        Directives.OrganizationSelectorLinkController = OrganizationSelectorLinkController;
        angular.module('app.Directives')
            .controller('OrganizationSelectorLinkController', OrganizationSelectorLinkController);
    })(Directives = app.Directives || (app.Directives = {}));
})(app || (app = {}));
